export default __webpack_public_path__ + "static/media/PAPCaseThumbnail.b7278737.png";